import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ROUTE } from '../constant/route.constant';
import { BizflexFacade } from '../store';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly bizflexFacade = inject(BizflexFacade);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([this.bizflexFacade.accessToken$, this.bizflexFacade.applicationId$]).pipe(
      map(([accessToken, applicationId]) => {
        if (!accessToken) {
          return !applicationId
            ? this.router.createUrlTree([ROUTE.ERROR.MAIN, ROUTE.ERROR.FORBIDDEN])
            : this.router.createUrlTree([ROUTE.VERIFICATION.MAIN], {
                queryParams: { [ROUTE.VERIFICATION.QUERY_PARAM.CODE]: applicationId },
              });
        }
        return true;
      }),
    );
  }
}
